import { useNavigate } from "react-router-dom";
import { Data, ListFetch } from "../../lib/typeDeclarations";
import { useListRecords } from "../../server/hooks/getData";
import { useFilters } from "../../lib/setSearchParams";

import Header from "../../components/layout/Header";
import { TextInput } from "../../components/inputs/TextInput";
import { Autocomplete } from "../../components/inputs/Autocomplete";
import { FilterBar, Page, PageBody, PageHeader } from "../../components/layout/Page";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Loader } from "../../components/loader/Loader";
import { useState } from "react";
import { formatDate } from "../../lib/dateHelper";
import { addIcon } from "../../assets/icons";

export default function EtalonList() {
  document.title = "Etalonok";
  const navigate = useNavigate();

  //States

  const headers = ["Típus", "Gyártó", "Megnevezés", "Kalibrálás dátuma", "Újrakalibrálás dátuma"];
  const { filters, setFilters } = useFilters();

  const { data: etalonList, loading }: ListFetch = useListRecords(
    "etalon",
    [JSON.stringify(filters)],
    {
      ...filters,
      orderBy: "type",
      order: "ASC",
    }
  );

  //Functions
  const addMonths = (date: any, months: number) => {
    const result = new Date(date);
    result.setMonth(result.getMonth() + months);
    return formatDate(result);
  };

  //Component
  return (
    <Page>
      <Header
        itemCounter={{
          page: etalonList.page,
          limit: etalonList.limit,
          total: etalonList.total,
          setPage: setFilters,
        }}
      >
        <PrimaryButton
          btn={{ svgBefore: addIcon, text: "Létrehozás", onClick: () => navigate("new") }}
        />{" "}
      </Header>
      <PageHeader title="Etalonok" />
      <FilterBar>
        <TextInput stateKey="type" placeholder="Típus" state={filters} setState={setFilters} />
      </FilterBar>
      {!loading ? (
        <>
          <PageBody>
            <div className="listitem">
              <table>
                <thead>
                  <tr>
                    {headers.map(item => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {etalonList.data.length !== 0 ? (
                    etalonList.data.map(item => (
                      <tr key={item.id} onClick={() => navigate(`${item.id}`)}>
                        <td>{item.type}</td>
                        <td>{item.manufacturer}</td>
                        <td>{item.description}</td>
                        <td>{formatDate(item.last_calibration)}</td>
                        <td>
                          <div
                            className="status"
                            style={{
                              backgroundColor: `${
                                new Date(addMonths(item.last_calibration, item.cal_frequency)) <
                                new Date()
                                  ? "#dc2626"
                                  : "none"
                              }`,
                              color: `${
                                new Date(addMonths(item.last_calibration, item.cal_frequency)) <
                                new Date()
                                  ? "#ffffff"
                                  : ""
                              }`,
                            }}
                          >
                            <span style={{ color: `${item.status_color}` }}>
                              {addMonths(item.last_calibration, item.cal_frequency)}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={headers.length + 1} style={{ textAlign: "center" }}>
                        Nincs találat!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </PageBody>
        </>
      ) : (
        <Loader />
      )}
    </Page>
  );
}
